export const FIVE_YEAR_MIGRATION_STATUS = Object.freeze({
  NOT_MIGRATED: 0,
  CUTOVER_PENDING: 1,
  CUTOVER_COMPLETED: -1
});

export function normalizeFiveYearMigrationStatus(status) {
  const normalized = Number(status);

  if (
    normalized === FIVE_YEAR_MIGRATION_STATUS.CUTOVER_PENDING ||
    normalized === FIVE_YEAR_MIGRATION_STATUS.CUTOVER_COMPLETED
  ) {
    return normalized;
  }

  return FIVE_YEAR_MIGRATION_STATUS.NOT_MIGRATED;
}

export function isFiveYearMigratedCustomer(status) {
  const normalized = normalizeFiveYearMigrationStatus(status);
  return (
    normalized === FIVE_YEAR_MIGRATION_STATUS.CUTOVER_PENDING ||
    normalized === FIVE_YEAR_MIGRATION_STATUS.CUTOVER_COMPLETED
  );
}

export function isFiveYearMigrationPopupEligible(status) {
  return normalizeFiveYearMigrationStatus(status) === FIVE_YEAR_MIGRATION_STATUS.CUTOVER_PENDING;
}
